import React from 'react'
import { withProps } from 'recompose'

import Msg from '../components/Msg'
import Feedback from '../addons/feedback/Feedback'
import { getFeedbackCfg, getFeedbackDefinition } from '../app/selectors'
import content from '../content'

const ReportProblemPage = ({ feedbackCfg, feedbackDef }) => (
  <div>
    <Feedback
      cfg={feedbackCfg}
      subjectId={'report_problem'}
      definition={feedbackDef}
      submitButtonLabel={<Msg id="ReportProblemPage.submitButton" />}
      remember={false}
    />
  </div>
)

const feedbackCfg = getFeedbackCfg(content)

const withPageContent = withProps({
  feedbackDef: getFeedbackDefinition(content, 'reportProblem'),
  feedbackCfg,
})

export default withPageContent(ReportProblemPage)



// WEBPACK FOOTER //
// ./src/containers/ReportProblemPage.js